<!--政策法规详情页-->
<template>
    <div class="detailsBox">
          <div class="content">
              <div class="pageTitle" v-html="newsData.title"></div>
              <div class="pageTime">发布时间：{{newsData.createDate}}      {{createBy}}</div>
              <div class="pageTitle01" v-html="newsData.subTitle">

              </div>
              <div class="pageText" v-html="htmlDecodeByRegExp(newsData.content)">
              </div>
            <div v-if="file_flag" class="pageText" >
              <a :href="url+'/api-file/files/downFileByfileId?client_id='+client_id+'&fileid='+newsData.files" style="color: #3A83F4;text-decoration-line:none"><span style="font-weight: bolder" class="el-icon-paperclip">点击下载附件</span></a>
            </div>
          </div>

           <div class="bottomMenu">
              <span @click="closeDetails">【关闭窗口】</span>
           </div>
    </div>

</template>

<script>
    export default {
        name: "policyDetails",
        data(){
            return{
			  id: this.$route.query.id,
              url: this.$Config.base_server,
              newsData:{},
              file_flag:false,
			  client_id:localStorage.getItem("client_id"),
			  routerName:'',
            }
        },
      created() {
        let _this = this;
        $.ajax({
          url: _this.url + "/api-base/oanotify/list/",
          type: "GET",
          data:{client_id: localStorage.getItem("client_id"),id:this.id,status:0},
          dataType: "json", //返回数据格式为json
          success: (res)=> {
            if ((res.data && res.data[0].files && res.data[0].files.length > 0)) {
              _this.file_flag = true
            }
            _this.newsData = res.data[0];
          },
          error: (err)=> {

          }
        });
      },

        beforeRouteEnter(to, from, next) {
            next(vm=>{
                vm.routerName = from.name;
            })
        },
      methods:{
        htmlDecodeByRegExp (str){
            var temp = "";
            if(str && str.length == 0) return "";
            temp = str.replace(/&amp;/g,"&");
            temp = temp.replace(/&lt;/g,"<");
            temp = temp.replace(/&gt;/g,">");
            temp = temp.replace(/&nbsp;/g," ");
            temp = temp.replace(/&#39;/g,"\'");
            temp = temp.replace(/&quot;/g,"\"");
            return temp;
        },
        closeDetails(){
            if(this.routerName == 'homeContent'){
                this.$emit('tablePage','首页');
            }
            this.$router.go(-1);
             // this.$router.push({path:'/homeContent'})
        }
        }
    }
</script>

<style scoped lang="scss">
    .detailsBox{
        width: 100%;
        .content{
            width: 100%;
            padding-top: 40px;
            .pageTitle{
                text-align: center;
                font-size: 24px;
                /*color: #333333;*/
            }
            .pageTime{
                font-size: 14px;
                color: #999999;
                text-align: center;
                margin-top: 10px;
            }
            .pageTitle01{
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                align-items: center;
                font-size: 16px;
                color: #666666;
              line-height: 30px;
              text-align: center;
            }
            .pageText{
              img{

              }
                font-size: 14px;
                margin-top: 20px;
                line-height: 30px;
                .row01{
                    margin-top: 50px;
                }
                .row03{
                    margin-top: 30px;
                }
            }
        }

        .bottomMenu{
            margin-top: 30px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
                cursor: pointer;
            }
            span:nth-of-type(2){
                margin-left: 50px;
            }
        }
    }

</style>
